var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg06Movies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_47)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5 0C115.643 0 149 33.3546 149 74.5C149 115.647 115.643 149.001 74.5 149.001C33.3534 149.001 -0.00119019 115.647 -0.00119019 74.5C-0.00119019 33.3546 33.3534 0 74.5 0Z",
    fill: "url(#paint0_linear_1_47)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9242 114.147H111.383V71.3789H37.9242V114.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8612 68.173L52.7186 68.384H64.7596L64.9023 68.173L72.4998 56.8992H60.4588L52.8612 68.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6899 68.173L76.5473 68.384H88.5884L88.731 68.173L96.3286 56.8992H84.2875L76.6899 68.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9242 68.384H40.9309L41.0735 68.173L48.6711 56.8992H37.9242V68.173V68.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.376 68.384H111.382V68.173V56.8992H108.116L100.519 68.173L100.376 68.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.429 42.119L59.7633 51.3407L71.432 48.3717L61.0976 39.15L49.429 42.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5222 36.2423L82.8554 45.464L94.524 42.495L84.1908 33.2733L72.5222 36.2423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6143 30.3655L105.949 39.5873L109.113 38.7822L106.281 27.6511L95.6143 30.3655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0055 45.0267L35.0919 45.7681L37.9242 56.8993L48.3387 54.2485L38.0055 45.0267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_47",
    x1: 127.18,
    y1: 127.181,
    x2: 21.8191,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E321"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06Movies);
export default __webpack_public_path__ + "static/media/06_movies.95b50109652c581e821a13a9a7b0f347.svg";
export { ForwardRef as ReactComponent };